import { render, staticRenderFns } from "./SetUserInfoEdit.vue?vue&type=template&id=9ed9aa8c"
import script from "./SetUserInfoEdit.vue?vue&type=script&lang=js"
export * from "./SetUserInfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports